// Auto-generated from MongoDB export
// Hero, Personal, and Contact content

export const hero_content = [
  {
    "id": "fe847319-5c4b-463e-98ab-0bb097f79bb0",
    "title": "GIDEON METRE",
    "subtitle": "Associate Director | Investment Management | Business Side AI-Driven Transformation",
    "ribbon_text": "Financial Leader | Tech-Driven | Vibe Coder | MBA | Mathematics Graduate",
    "cta_button_text": "Explore My Journey",
    "resume_button_text": "Request Resume",
    "achievements": {
      "experience": {
        "value": "~15",
        "label": "Years Experience"
      },
      "team": {
        "value": "19+",
        "label": "Team Members"
      },
      "savings": {
        "value": "1600+",
        "label": "FTE Hours Saved"
      },
      "engagement": {
        "value": "98%",
        "label": "Engagement Score"
      }
    },
    "background_image": "https://images.unsplash.com/photo-1738566061977-fdd59ca5b08e",
    "updated_at": "2025-09-04T18:48:11.177000"
  }
];

export const personal_content = [
  {
    "id": "60bb671d-250d-416c-8fd3-5e5bb23c2f01",
    "section_title": "About Gideon",
    "section_subtitle": "A results-driven professional with ~15 years of progressive experience in front-office portfolio management, AI-driven transformation, and building high-performance teams that deliver exceptional results across equities, FX, derivatives, and multi-asset mandates.",
    "overview": {
      "leadership": {
        "title": "Leadership Excellence",
        "description": "Currently leading 19+ professionals across 9 cross-functional teams at Russell Investments, reporting directly to Global MD with responsibility for front-office Implementation Portfolio Management.",
        "badges": [
          "Team Building",
          "Strategic Leadership",
          "Global Management"
        ]
      },
      "innovation": {
        "title": "AI & Automation Pioneer",
        "description": "India AI Management Sponsor, developed 40+ Alteryx workflows and 10+ VBA automation projects, delivering 1600+ FTE hours of capacity savings with ~70% processing time reduction through 40+ automation deployments.",
        "badges": [
          "Alteryx",
          "VBA",
          "Process Automation"
        ]
      },
      "journey": [
        {
          "company": "Russell Investments",
          "position": "Associate Director",
          "period": "Mar 2024 - Present",
          "description": "Leading Implementation Portfolio Management (Front Office) & India AI Management Sponsor"
        },
        {
          "company": "TIAA GBS",
          "position": "Senior Associate/Manager",
          "period": "Jan 2019 - Mar 2024",
          "description": "Investment Accounting & Reporting, Business Intelligence, Process Automation, Fund Administration"
        },
        {
          "company": "FIS (SunGard)",
          "position": "Senior Analyst",
          "period": "Feb 2017 - Jan 2019",
          "description": "Post-Trade Derivatives Collateral Management"
        },
        {
          "company": "BNY Mellon",
          "position": "Analyst",
          "period": "Nov 2013 - Feb 2017",
          "description": "Prime Brokerage & Custody, Client Service"
        },
        {
          "company": "EXL Services",
          "position": "Customer Support Representative",
          "period": "Aug 2010 - Oct 2011",
          "description": "General Insurance Operations"
        }
      ]
    },
    "experience": [],
    "skills": {
      "technical": [
        "Alteryx Analytics (Certified)",
        "VBA Programming",
        "SQL",
        "Power BI",
        "Python",
        "Bloomberg AIM",
        "Microsoft Power Automate",
        "SharePoint",
        "Gen AI Agent Development",
        "Vibe Coding"
      ],
      "domain": [
        "Front-Office Portfolio Management",
        "Asset Management",
        "OTC Derivatives & Collateral Mgmt.",
        "Investment Accounting & Reporting",
        "Fund Administration",
        "Prime Brokerage",
        "Capital Markets",
        "Multi-Asset Class Coverage",
        "GCC Process Setup"
      ],
      "leadership": [
        "Greenfield GCC Setup & Scaling",
        "Cross-functional Leadership",
        "Business-Side AI Adoption & Governance",
        "US-to-India Business Transitions",
        "Strategic Planning",
        "Stakeholder Management",
        "Performance Management",
        "High-Retention Team Culture"
      ]
    },
    "achievements": [],
    "updated_at": "2025-09-04T18:13:19.467000"
  }
];

export const contact_content = [
  {
    "id": "a99c95ae-6638-4346-8839-13bafe46863c",
    "section_title": "Let's Connect",
    "section_subtitle": "Ready to collaborate on your next AI implementation, automation project, or team building initiative? Let's discuss how we can drive innovation together.",
    "linkedin_url": "https://www.linkedin.com/in/gideon-metre",
    "availability_status": "Available for Collaboration",
    "availability_text": "Lets connect",
    "updated_at": "2025-09-04T18:03:23.394000"
  }
];

